export const GLOBAL_PAYMENT_HEADER = [
  { id: 1, title: '거래 일시', flex: 1.6 },
  // { id: 2, title: '환급 여부', flex: 1 },
  { id: 3, title: '간편 결제 거래 상태', flex: 1.5 },
  { id: 4, title: '', flex: 3 },
  { id: 5, title: '결제 수단', flex: 1.65 },
  { id: 6, title: '결제 금액', flex: 1.5 },
  { id: 7, title: '결제 취소', flex: 1 },
];
